import { useSession } from "hooks/useSession";
import React from "react";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
export default function DeleteModal({ id, title, message, apiUrl, onSuccess, deleteid, deleteKey }) {

  const { userid } = useSession();
  const handleDelete = async () => {
    const formData = new FormData();

    const targetId = typeof deleteid === "object" && deleteid !== null
      ? (deleteid.id || deleteid.ticket_id || deleteid._id)
      : deleteid;

    formData.append("id", targetId ?? "");
    formData.append("userid", userid);
    formData.append("action", "DELETE");
    if (deleteKey) {
      formData.append(deleteKey, targetId ?? "");
    }

    try {
      const response = await fetchWrapper(apiUrl, {
        method: "POST",
        body: formData,
      });
      const result = response;

      const isSuccess =
        result?.status === "success" ||
        result?.status === true ||
        result?.success === true ||
        result?.status === 1 ||
        (result?.status && result?.status !== "error");

      if (isSuccess) {
        showMainToast(result.message || result.data || "Deleted successfully!", "success");
        if (onSuccess) onSuccess(); // refresh list, etc.

        // Close modal programmatically
        const modalEl = document.getElementById(id);
        if (modalEl && window.bootstrap?.Modal) {
          const modal = window.bootstrap.Modal.getInstance(modalEl) || window.bootstrap.Modal.getOrCreateInstance(modalEl);
          modal?.hide();
        }
      } else {
        showMainToast(result?.message || result?.data || "Failed to delete", "danger");
      }
    } catch (error) {
      console.error(error);
      showMainToast("Server error, please try again later", "danger");
    }
  };

  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-danger">
            <h5 className="modal-title text-white">{title || "Confirm Delete"}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <h5 className="text-danger">
              {message || "Are you sure you want to delete this item?"}
            </h5>
          </div>
          <div className="modal-footer">
            <button className="btn btn-danger" type="button" onClick={handleDelete}>
              Delete
            </button>
            <button
              className="btn btn-light-secondary"
              data-bs-dismiss="modal"
              type="button"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
